import * as React from "react";
const SvgAgent = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.252 1.69v8.5l-1.002-1-1-1-.531.529-.53.531 1.905 1.904L12 13.061l1.906-1.907 1.905-1.904-.53-.531-.531-.53-1 1-1.002 1v-8.5H12ZM4.215 5.624v9.98l-1.358 3.26-1.359 3.258 5.252.002h10.5l5.252-.002-1.357-3.258-1.36-3.26v-9.98h-2.629v1.498h1.123V14.996H5.723V7.123h1.123V5.625H5.529Zm1.258 10.877 6.529.002 6.531.004.856 2.055.855 2.052-4.121.004H7.879l-4.123-.004.844-2.025.857-2.057z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgAgent;
